/**
 * The virtual-background id space.
 *
 * The picker's options are mutually exclusive, so they share one id: `''` (no background), `'blur'`,
 * or `custom:<uuid>` for an image the user picked from their own device (held in this browser only —
 * see `webRTC/services/customBackgroundStorage`).
 *
 * A prefix on the id rather than a second field, because the whole pipeline — form field →
 * `settingsUpdated` → `userSlice` → `localStorage` → apply — already carries exactly one string, and
 * `isCustomBackgroundId` is synchronous, so it can be used even at slice-init time.
 *
 * This used to hold a second tenant: `VIDEO_BACKGROUNDS`, a hard-coded list of bundled artwork gated
 * to one client's accounts. That pilot is over, and removing it also removes the seam it documented
 * for backend-served backgrounds. Deliberate rather than lost: the seam was one array of
 * `{ id, name, imageUrl }` plus a lookup, and `applyBackground` still takes a URL rather than an id,
 * so it can be reinstated exactly the way it was removed.
 */
import { uuid } from 'common/utils';

export const NO_BACKGROUND_ID = '';
export const BLUR_BACKGROUND_ID = 'blur';

export const CUSTOM_BACKGROUND_ID_PREFIX = 'custom:';

export const isCustomBackgroundId = (id: string) => id.startsWith(CUSTOM_BACKGROUND_ID_PREFIX);

export const createCustomBackgroundId = () => `${CUSTOM_BACKGROUND_ID_PREFIX}${uuid()}`;
